/**
 * Renders JSON-LD for search engines (§45). The content is built by
 * `@/utils/structuredData`, never inline, so no page invents its own facts.
 */
export function StructuredData({
  data,
}: {
  data: Record<string, unknown> | Record<string, unknown>[];
}) {
  return (
    <script
      type="application/ld+json"
      // The payload is built from our own typed data, not from user input.
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
